// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","532":"styles"}[chunkId] + "-" + {"230":"a731321da84cd2fa0b4f","256":"c221215d5e0934888f97","532":"4fffce1ecfea467ce4da"}[chunkId] + ".js";
};